import { Color } from "../../../maths/Color";
import { Matrix3x3 } from "../../../maths/Matrix3x3";
import { Matrix4x4 } from "../../../maths/Matrix4x4";
import { Vector2 } from "../../../maths/Vector2";
import { Vector3 } from "../../../maths/Vector3";
import { Vector4 } from "../../../maths/Vector4";
import { Resource } from "../../../resource/Resource";
import { WebGLEngine } from "../../WebGLDriver/RenderDevice/WebGLEngine";
import { isRenderStateProperty, ShaderData } from "../../DriverDesign/RenderDevice/ShaderData";
import { WebDefineDatas } from "./WebDefineDatas";
import { WebGLUniformBuffer } from "../../WebGLDriver/RenderDevice/WebGLUniformBuffer";
import { WebGLSubUniformBuffer } from "../../WebGLDriver/RenderDevice/WebGLSubUniformBuffer";
import { WebGLUniformBufferBase } from "../../WebGLDriver/RenderDevice/WebGLUniformBufferBase";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { Config } from "../../../../Config";
import { LayaGL } from "../../../layagl/LayaGL";
import { RenderState } from "../Design/RenderState";
export class WebGLShaderData extends ShaderData {
    get renderStateChanged() {
        return this._renderStateChanged;
    }
    updateRenderState() {
        var _a, _b, _c;
        this._renderStateChanged = false;
        const datas = this.getData();
        const renderState = this.renderState;
        let depthWrite = datas[Shader3D.DEPTH_WRITE];
        depthWrite = depthWrite !== null && depthWrite !== void 0 ? depthWrite : RenderState.Default.depthWrite;
        renderState.depthWrite = depthWrite;
        let depthTest = datas[Shader3D.DEPTH_TEST];
        depthTest = depthTest !== null && depthTest !== void 0 ? depthTest : RenderState.Default.depthTest;
        renderState.depthTest = depthTest;
        let stencilWrite = datas[Shader3D.STENCIL_WRITE];
        stencilWrite = stencilWrite !== null && stencilWrite !== void 0 ? stencilWrite : RenderState.Default.stencilWrite;
        renderState.stencilWrite = stencilWrite;
        let stencilWriteMask = ((_a = datas[Shader3D.STENCIL_WRITE_MASK]) !== null && _a !== void 0 ? _a : RenderState.Default.stencilWriteMask);
        renderState.stencilWriteMask = stencilWriteMask;
        let stencilOp = datas[Shader3D.STENCIL_Op];
        stencilOp = stencilOp !== null && stencilOp !== void 0 ? stencilOp : RenderState.Default.stencilOp;
        renderState.stencilOp.set(stencilOp.x, stencilOp.y, stencilOp.z);
        let stencilTest = datas[Shader3D.STENCIL_TEST];
        stencilTest = stencilTest !== null && stencilTest !== void 0 ? stencilTest : RenderState.Default.stencilTest;
        renderState.stencilTest = stencilTest;
        let stencilReadMask = (_b = datas[Shader3D.STENCIL_READ_MASK]) !== null && _b !== void 0 ? _b : RenderState.Default.stencilReadMask;
        renderState.stencilReadMask = stencilReadMask;
        var stencilRef = datas[Shader3D.STENCIL_Ref];
        stencilRef = stencilRef !== null && stencilRef !== void 0 ? stencilRef : RenderState.Default.stencilRef;
        renderState.stencilRef = stencilRef;
        let depthBias = (_c = datas[Shader3D.DEPTH_BIAS]) !== null && _c !== void 0 ? _c : RenderState.Default.depthBias;
        renderState.depthBias = depthBias;
        let depthBiasConstant = datas[Shader3D.DEPTH_BIAS_CONSTANT];
        depthBiasConstant = depthBiasConstant !== null && depthBiasConstant !== void 0 ? depthBiasConstant : RenderState.Default.depthBiasConstant;
        renderState.depthBiasConstant = depthBiasConstant;
        let depthBiasSlopeScale = datas[Shader3D.DEPTH_BIAS_SLOPESCALE];
        depthBiasSlopeScale = depthBiasSlopeScale !== null && depthBiasSlopeScale !== void 0 ? depthBiasSlopeScale : RenderState.Default.depthBiasSlopeScale;
        renderState.depthBiasSlopeScale = depthBiasSlopeScale;
        let depthBiasClamp = datas[Shader3D.DEPTH_BIAS_CLAMP];
        depthBiasClamp = depthBiasClamp !== null && depthBiasClamp !== void 0 ? depthBiasClamp : RenderState.Default.depthBiasClamp;
        renderState.depthBiasClamp = depthBiasClamp;
        let blend = datas[Shader3D.BLEND];
        blend = blend !== null && blend !== void 0 ? blend : RenderState.Default.blend;
        renderState.blend = blend;
        let blendEquation = datas[Shader3D.BLEND_EQUATION];
        blendEquation = blendEquation !== null && blendEquation !== void 0 ? blendEquation : RenderState.Default.blendEquation;
        renderState.blendEquation = blendEquation;
        let srcBlend = datas[Shader3D.BLEND_SRC];
        srcBlend = srcBlend !== null && srcBlend !== void 0 ? srcBlend : RenderState.Default.srcBlend;
        renderState.srcBlend = srcBlend;
        let dstBlend = datas[Shader3D.BLEND_DST];
        dstBlend = dstBlend !== null && dstBlend !== void 0 ? dstBlend : RenderState.Default.dstBlend;
        renderState.dstBlend = dstBlend;
        let blendEquationRGB = datas[Shader3D.BLEND_EQUATION_RGB];
        blendEquationRGB = blendEquationRGB !== null && blendEquationRGB !== void 0 ? blendEquationRGB : RenderState.Default.blendEquationRGB;
        renderState.blendEquationRGB = blendEquationRGB;
        let blendEquationAlpha = datas[Shader3D.BLEND_EQUATION_ALPHA];
        blendEquationAlpha = blendEquationAlpha !== null && blendEquationAlpha !== void 0 ? blendEquationAlpha : RenderState.Default.blendEquationAlpha;
        renderState.blendEquationAlpha = blendEquationAlpha;
        let srcRGB = datas[Shader3D.BLEND_SRC_RGB];
        srcRGB = srcRGB !== null && srcRGB !== void 0 ? srcRGB : RenderState.Default.srcBlendRGB;
        renderState.srcBlendRGB = srcRGB;
        let dstRGB = datas[Shader3D.BLEND_DST_RGB];
        dstRGB = dstRGB !== null && dstRGB !== void 0 ? dstRGB : RenderState.Default.dstBlendRGB;
        renderState.dstBlendRGB = dstRGB;
        let srcAlpha = datas[Shader3D.BLEND_SRC_ALPHA];
        srcAlpha = srcAlpha !== null && srcAlpha !== void 0 ? srcAlpha : RenderState.Default.srcBlendAlpha;
        renderState.srcBlendAlpha = srcAlpha;
        let dstAlpha = datas[Shader3D.BLEND_DST_ALPHA];
        dstAlpha = dstAlpha !== null && dstAlpha !== void 0 ? dstAlpha : RenderState.Default.dstBlendAlpha;
        renderState.dstBlendAlpha = dstAlpha;
        let cull = datas[Shader3D.CULL];
        cull = cull !== null && cull !== void 0 ? cull : RenderState.Default.cull;
        renderState.cull = cull;
        const engine = WebGLEngine.instance;
        const hash = engine.hashRenderState(renderState);
        renderState.hash = hash;
        this._renderStateChanged = false;
    }
    _checkRenderState(index) {
        if (isRenderStateProperty(index)) {
            this._renderStateChanged = true;
        }
    }
    constructor(ownerResource = null) {
        super(ownerResource);
        this._data = null;
        this._defineDatas = new WebDefineDatas();
        this._id = WebGLShaderData.pointerCount++;
        this._needCacheData = false;
        this._updateCacheArray = null;
        this._subUboBufferNumber = 0;
        this._renderStateChanged = true;
        this.renderState = new RenderState();
        this._initData();
    }
    _initData() {
        this._data = {};
        this._updateCacheArray = {};
        this._gammaColorMap = new Map();
        this._uniformBuffers = new Map();
        this._subUniformBuffers = new Map();
        this._uniformBuffersPropertyMap = new Map();
    }
    createUniformBuffer(name, uniformMap, needUpdata = false) {
        if (this._uniformBuffers.has(name)) {
            if (needUpdata) {
                this._updateUBOBuffer(name);
            }
            return this._uniformBuffers.get(name);
        }
        this._needCacheData = true;
        let uboBuffer = new WebGLUniformBuffer(name);
        uniformMap.forEach(uniform => {
            uboBuffer.addUniform(uniform.id, uniform.uniformtype, uniform.arrayLength);
        });
        uboBuffer.create();
        this._uniformBuffers.set(name, uboBuffer);
        let id = Shader3D.propertyNameToID(name);
        this._data[id] = uboBuffer;
        uniformMap.forEach(uniform => {
            let uniformId = uniform.id;
            let data = this._data[uniformId];
            if (data != null) {
                uboBuffer.setUniformData(uniformId, uniform.uniformtype, data);
            }
            this._uniformBuffersPropertyMap.set(uniformId, uboBuffer);
        });
        uboBuffer.needUpload && uboBuffer.upload();
        return uboBuffer;
    }
    _updateUBOBuffer(name) {
        if (!Config._uniformBlock) {
            return;
        }
        let buffer = this._uniformBuffers.get(name) || this._subUniformBuffers.get(name);
        if (!buffer) {
            return;
        }
        for (var i in this._updateCacheArray) {
            let index = parseInt(i);
            let ubo = this._uniformBuffersPropertyMap.get(index);
            if (ubo) {
                this._updateCacheArray[i].call(ubo, index, this._data[index]);
            }
        }
        this._updateCacheArray = {};
        buffer.needUpload && buffer.upload();
    }
    createSubUniformBuffer(name, cacheName, uniformMap) {
        let subBuffer = this._subUniformBuffers.get(cacheName);
        if (subBuffer) {
            if (this._subUboBufferNumber < 2) {
                for (var i in this._updateCacheArray) {
                    let index = parseInt(i);
                    let ubo = this._uniformBuffersPropertyMap.get(index);
                    if (ubo) {
                        this._updateCacheArray[i].call(ubo, index, this._data[index]);
                    }
                }
                this._updateCacheArray = {};
            }
            else {
                uniformMap.forEach((uniform, index) => {
                    if (this._data[index] && this._updateCacheArray[index]) {
                        this._updateCacheArray[index].call(subBuffer, index, this._data[index]);
                    }
                });
            }
            return subBuffer;
        }
        let engine = WebGLEngine.instance;
        let mgr = engine.bufferMgr;
        let uniformBuffer = new WebGLSubUniformBuffer(name, uniformMap, mgr, this);
        this._subUboBufferNumber++;
        this._needCacheData = true;
        uniformBuffer.notifyGPUBufferChange();
        this._subUniformBuffers.set(cacheName, uniformBuffer);
        let id = Shader3D.propertyNameToID(name);
        this._data[id] = uniformBuffer;
        uniformMap.forEach(uniform => {
            let uniformId = uniform.id;
            let data = this._data[uniformId];
            if (data != null) {
                uniformBuffer.setUniformData(uniformId, uniform.uniformtype, data);
            }
            this._uniformBuffersPropertyMap.set(uniformId, uniformBuffer);
        });
        return uniformBuffer;
    }
    getData() {
        return this._data;
    }
    addDefine(define) {
        this._defineDatas.add(define);
    }
    addDefines(define) {
        this._defineDatas.addDefineDatas(define);
    }
    removeDefine(define) {
        this._defineDatas.remove(define);
    }
    removeDefines(defines) {
        this._defineDatas.removeDefineDatas(defines);
    }
    hasDefine(define) {
        return this._defineDatas.has(define);
    }
    clearDefine() {
        this._defineDatas.clear();
    }
    clearData() {
        for (const key in this._data) {
            if (this._data[key] instanceof Resource) {
                this._data[key]._removeReference();
            }
        }
        this._uniformBuffersPropertyMap.clear();
        this._uniformBuffers.forEach(buffer => {
            buffer.destroy();
        });
        this._uniformBuffers.clear();
        this._subUniformBuffers.forEach(buffer => {
            buffer.destroy();
        });
        this._subUniformBuffers.clear();
        this._data = {};
        this._gammaColorMap.clear();
        this.clearDefine();
        this._needCacheData = false;
        this._subUboBufferNumber = 0;
        this.renderState.setNull();
    }
    getBool(index) {
        return this._data[index];
    }
    setBool(index, value) {
        this._data[index] = value;
        if (this._needCacheData) {
        }
        this._checkRenderState(index);
    }
    getInt(index) {
        return this._data[index];
    }
    setInt(index, value) {
        this._data[index] = value;
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setInt;
        }
        this._checkRenderState(index);
    }
    getNumber(index) {
        return this._data[index];
    }
    setNumber(index, value) {
        this._data[index] = value;
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setFloat;
        }
        this._checkRenderState(index);
    }
    getVector2(index) {
        return this._data[index];
    }
    setVector2(index, value) {
        if (this._data[index]) {
            value.cloneTo(this._data[index]);
        }
        else
            this._data[index] = value.clone();
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setVector2;
        }
    }
    getVector3(index) {
        return this._data[index];
    }
    setVector3(index, value) {
        if (this._data[index]) {
            value.cloneTo(this._data[index]);
        }
        else
            this._data[index] = value.clone();
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setVector3;
        }
    }
    getVector(index) {
        return this._data[index];
    }
    setVector(index, value) {
        if (this._data[index]) {
            value.cloneTo(this._data[index]);
        }
        else
            this._data[index] = value.clone();
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setVector4;
        }
    }
    getColor(index) {
        return this._gammaColorMap.get(index);
    }
    setColor(index, value) {
        if (!value)
            return;
        if (this._data[index]) {
            let gammaColor = this._gammaColorMap.get(index);
            value.cloneTo(gammaColor);
            let linearColor = this._data[index];
            linearColor.x = Color.gammaToLinearSpace(value.r);
            linearColor.y = Color.gammaToLinearSpace(value.g);
            linearColor.z = Color.gammaToLinearSpace(value.b);
            linearColor.w = value.a;
        }
        else {
            let linearColor = new Vector4();
            linearColor.x = Color.gammaToLinearSpace(value.r);
            linearColor.y = Color.gammaToLinearSpace(value.g);
            linearColor.z = Color.gammaToLinearSpace(value.b);
            linearColor.w = value.a;
            this._data[index] = linearColor;
            this._gammaColorMap.set(index, value.clone());
        }
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setVector4;
        }
    }
    getLinearColor(index) {
        return this._data[index];
    }
    getMatrix4x4(index) {
        return this._data[index];
    }
    setMatrix4x4(index, value) {
        if (this._data[index]) {
            value.cloneTo(this._data[index]);
        }
        else {
            this._data[index] = value.clone();
        }
        if (this._needCacheData)
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setMatrix4x4;
    }
    getMatrix3x3(index) {
        return this._data[index];
    }
    setMatrix3x3(index, value) {
        if (this._data[index]) {
            value.cloneTo(this._data[index]);
        }
        else {
            this._data[index] = value.clone();
        }
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setMatrix3x3;
        }
    }
    getBuffer(index) {
        return this._data[index];
    }
    setBuffer(index, value) {
        this._data[index] = value;
        if (this._needCacheData) {
            this._updateCacheArray[index] = WebGLUniformBufferBase.prototype.setArrayBuffer;
        }
    }
    setTexture(index, value) {
        var lastValue = this._data[index];
        if (value) {
            let shaderDefine = WebGLEngine._texGammaDefine[index];
            if (shaderDefine && value && value.gammaCorrection > 1) {
                this.addDefine(shaderDefine);
            }
            else {
                shaderDefine && this.removeDefine(shaderDefine);
            }
        }
        this._data[index] = value;
        lastValue && lastValue._removeReference();
        value && value._addReference();
    }
    _setInternalTexture(index, value) {
        var lastValue = this._data[index];
        if (value) {
            let shaderDefine = WebGLEngine._texGammaDefine[index];
            if (shaderDefine && value && value.gammaCorrection > 1) {
                this.addDefine(shaderDefine);
            }
            else {
                shaderDefine && this.removeDefine(shaderDefine);
            }
        }
        this._data[index] = value;
    }
    uploadCache() {
        let uploaded = false;
        for (let i in this._updateCacheArray) {
            uploaded = true;
            let index = parseInt(i);
            let ubo = this._uniformBuffersPropertyMap.get(index);
            if (ubo) {
                this._updateCacheArray[i].call(ubo, index, this._data[index]);
            }
        }
        if (uploaded) {
            this._updateCacheArray = {};
        }
    }
    update(name) {
        if (Config._uniformBlock) {
            let unifomrMap = LayaGL.renderDeviceFactory.createGlobalUniformMap(name);
            let uniformBuffer = this.createSubUniformBuffer(name, name, unifomrMap._idata);
            if (uniformBuffer) {
                uniformBuffer.upload();
            }
        }
    }
    getTexture(index) {
        return this._data[index];
    }
    getSourceIndex(value) {
        for (var i in this._data) {
            if (this._data[i] == value)
                return Number(i);
        }
        return -1;
    }
    cloneTo(destObject) {
        destObject.clearData();
        var destData = destObject._data;
        for (var k in this._data) {
            var value = this._data[k];
            if (value != null) {
                if (typeof value == "number") {
                    destData[k] = value;
                }
                else if (typeof value == "boolean") {
                    destData[k] = value;
                }
                else if (value instanceof Vector2) {
                    let v2 = destData[k] || (destData[k] = new Vector2());
                    value.cloneTo(v2);
                }
                else if (value instanceof Vector3) {
                    let v3 = destData[k] || (destData[k] = new Vector3());
                    value.cloneTo(v3);
                }
                else if (value instanceof Vector4) {
                    let color = this.getColor(parseInt(k));
                    if (color) {
                        let clonecolor = color.clone();
                        destObject.setColor(parseInt(k), clonecolor);
                    }
                    else {
                        let v4 = destData[k] || (destData[k] = new Vector4());
                        value.cloneTo(v4);
                    }
                }
                else if (value instanceof Matrix3x3) {
                    let mat = destData[k] || (destData[k] = new Matrix3x3());
                    value.cloneTo(mat);
                }
                else if (value instanceof Matrix4x4) {
                    let mat = destData[k] || (destData[k] = new Matrix4x4());
                    value.cloneTo(mat);
                }
                else if (value instanceof Resource) {
                    destData[k] = value;
                    value._addReference();
                }
            }
        }
        this._defineDatas.cloneTo(destObject._defineDatas);
        this._gammaColorMap.forEach((color, index) => {
            destObject._gammaColorMap.set(index, color.clone());
        });
    }
    getDefineData() {
        return this._defineDatas;
    }
    clone() {
        var dest = new WebGLShaderData();
        this.cloneTo(dest);
        return dest;
    }
    destroy() {
        if (this.destroyed) {
            return;
        }
        this.clearData();
        this._defineDatas.destroy();
        this._defineDatas = null;
        this.destroyed = true;
    }
}
WebGLShaderData.pointerCount = 0;
